interface UploadResponse {
  default: string;
}

type Upload = (file: File) => Promise<UploadResponse>;

// ref: https://ckeditor.com/docs/ckeditor5/latest/framework/guides/deep-dive/upload-adapter.html
class PhotoUploadAdapter {
  constructor(private loader, private onUpload: Upload) {}

  async upload() {
    const file = await this.loader.file;
    // FIXME Why is return required?
    const r = await this.onUpload(file);
    return r;
  }
}

export default (onUpload: Upload) => {
  return editor => {
    editor.plugins.get('FileRepository').createUploadAdapter = loader => {
      return new PhotoUploadAdapter(loader, onUpload);
    };
  };
};
